import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Loader from "../../../components/widgets/Loader";
import LoaderAccessesTableComponent from "../../../components/orders/loaderAccesses/LoaderAccessesTableComponent";
import { useStoreActions, useStoreState } from "easy-peasy";

const LoaderAccessesList = () => {
    const { allLoaderAccesses, isFetchingAllLoaderAccesses } = useStoreState(state => state.orders);
    const { fetchLoaderAccesses } = useStoreActions(actions => actions.orders);

    useEffect(() => {
        fetchLoaderAccesses();
    }, []);


    return <Container fluid>
        <Row>
            {isFetchingAllLoaderAccesses 
                ? <Loader />
                : <LoaderAccessesTableComponent loaderAccesses={allLoaderAccesses} />
            }
        </Row>
    </Container>
}

export default LoaderAccessesList;